/**
 * Scaling (Phase 10) ↔ draft mapping, on the verdict satellite: the
 * performing rule, the growth step, the amount cap and the "unless" guard —
 * and Phase 31's weak rule with its shrink step and floor. Advanced trees
 * are preserved by OMISSION on save, like the terrible rule.
 * For Media Devoted | Created By Ciro Autiero
 */
import { DROPS_SOURCE, type DropGenVerdictDetail, parseVerdictSources } from '@trafficpulse/shared';

import type { DraftScaling } from '../../../../drop-generator.types';
import { flatRuleToTree, parseFlatRule } from './verdict-draft';

export const DEFAULT_SCALING: DraftScaling = {
  performing: { join: 'AND', rows: [], advanced: false },
  stepPct: 25,
  maxAmount: null,
  guard: { join: 'AND', rows: [], advanced: false },
  weak: { join: 'AND', rows: [], advanced: false },
  shrinkPct: 25,
  minAmount: null,
  source: DROPS_SOURCE,
};

export function scalingToDraft(v: DropGenVerdictDetail | null): DraftScaling {
  if (!v) return { ...DEFAULT_SCALING };
  return {
    performing: parseFlatRule(v.scalingJson),
    stepPct: v.scaleStepPct,
    maxAmount: v.scaleMaxAmount,
    guard: parseFlatRule(v.scaleGuardJson),
    weak: parseFlatRule(v.weakJson ?? null),
    shrinkPct: v.shrinkStepPct ?? DEFAULT_SCALING.shrinkPct,
    minAmount: v.scaleMinAmount ?? null,
    source: parseVerdictSources(v.sourcesJson).scaling,
  };
}

/** The verdict PUT's scaling fields; an advanced tree is simply not sent. */
export function scalingToBody(draft: DraftScaling): Record<string, unknown> {
  return {
    scaleStepPct: draft.stepPct,
    scaleMaxAmount: draft.maxAmount,
    shrinkStepPct: draft.shrinkPct,
    scaleMinAmount: draft.minAmount,
    ...(draft.performing.advanced ? {} : { scalingJson: flatRuleToTree(draft.performing) }),
    ...(draft.guard.advanced ? {} : { scaleGuardJson: flatRuleToTree(draft.guard) }),
    ...(draft.weak.advanced ? {} : { weakJson: flatRuleToTree(draft.weak) }),
  };
}
